"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 初始化SDK实例
 * @param config 配置项
 * @returns SDK实例
 */
function initClient(SDK, config) {
    return new SDK({
        access_key_id: config.accessKeyId,
        secret_access_key: config.accessKeySecret,
        security_token: config.stsToken,
        server: "https://obs." + config.region + ".myhuaweicloud.com"
    });
}
/** 获取存储对象的URL地址 */
function getObjectURL(bucket, region, key, securty) {
    if (securty === void 0) { securty = true; }
    var origin = (securty ? 'https' : 'http') + "://" + bucket + ".obs." + region + ".myhuaweicloud.com";
    if (key.startsWith('/')) {
        return origin + key;
    }
    else {
        return origin + '/' + key;
    }
}
/**
 * 分段上传
 * @param client SDK实例
 * @param file 需要上传的文件
 * @param uploadConfig 上传配置
 * @param userConfig 实例的配置
 * @returns Promise
 */
function upload(client, file, uploadConfig, userConfig) {
    var key = userConfig.key, bucket = userConfig.bucket, region = userConfig.region;
    var cp;
    // let hook
    return new Promise(function (resolve, reject) {
        client.uploadFile({
            Key: key.startsWith('/') ? key.slice(1) : key,
            Bucket: bucket,
            SourceFile: file,
            ProgressCallback: function (transferredAmount, totalAmount) {
                var percent = transferredAmount / totalAmount;
                uploadConfig.progress && uploadConfig.progress(percent);
            },
            ResumeCallback: function (_, uploadCheckpoint) {
                // 获取取消断点续传上传任务控制参数
                // hook = resumeHook
                // 记录断点
                cp = uploadCheckpoint;
            }
        }, function (err, result) {
            if (err) {
                console.error('Error-->' + err);
                // 出现错误，再次调用断点续传接口，继续上传任务
                client.uploadFile({
                    UploadCheckpoint: cp,
                    ProgressCallback: function (transferredAmount, totalAmount) {
                        var percent = transferredAmount / totalAmount;
                        uploadConfig.progress && uploadConfig.progress(percent);
                    }
                }, function (err, result) {
                    if (err) {
                        console.error('Error-->' + err);
                        reject(err);
                    }
                    else {
                        console.log('result: ', result);
                        resolve({
                            status: result.CommonMsg.Status,
                            data: {
                                url: getObjectURL(bucket, region, key),
                                key: key
                            }
                        });
                    }
                });
            }
            else {
                console.log('result: ', result);
                resolve({
                    status: result.CommonMsg.Status,
                    data: {
                        url: getObjectURL(bucket, region, key),
                        key: key
                    }
                });
            }
        });
    });
}
/**
 * 图片处理
 * @param url 图片链接
 * @param config 配置参数
 * @returns 返回图片处理 url 拼接字符串
 */
function processImage(url, config) {
    var processURL = url + "?x-image-process=image/resize,w_" + config.resize.w;
    if (config.resize.h) {
        processURL += ",h_" + config.resize.h;
    }
    return processURL;
}
exports.default = {
    initClient: initClient,
    upload: upload,
    processImage: processImage
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9vYnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQTs7OztHQUlHO0FBQ0gsU0FBUyxVQUFVLENBQUMsR0FBUSxFQUFFLE1BQW1CO0lBQy9DLE9BQU8sSUFBSSxHQUFHLENBQUM7UUFDYixhQUFhLEVBQUUsTUFBTSxDQUFDLFdBQVc7UUFDakMsaUJBQWlCLEVBQUUsTUFBTSxDQUFDLGVBQWU7UUFDekMsY0FBYyxFQUFFLE1BQU0sQ0FBQyxRQUFRO1FBQy9CLE1BQU0sRUFBRSxpQkFBZSxNQUFNLENBQUMsTUFBTSx1QkFBb0I7S0FDekQsQ0FBQyxDQUFBO0FBQ0osQ0FBQztBQUVELG1CQUFtQjtBQUNuQixTQUFTLFlBQVksQ0FBQyxNQUFjLEVBQUUsTUFBYyxFQUFFLEdBQVcsRUFBRSxPQUFjO0lBQWQsd0JBQUEsRUFBQSxjQUFjO0lBQy9FLElBQU0sTUFBTSxHQUFHLENBQUcsT0FBTyxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLE1BQU0sWUFBTSxNQUFNLGFBQVEsTUFBTSx1QkFBb0IsQ0FBQTtJQUMxRixJQUFJLEdBQUcsQ0FBQyxVQUFVLENBQUMsR0FBRyxDQUFDLEVBQUU7UUFDdkIsT0FBTyxNQUFNLEdBQUcsR0FBRyxDQUFBO0tBQ3BCO1NBQU07UUFDTCxPQUFPLE1BQU0sR0FBRyxHQUFHLEdBQUcsR0FBRyxDQUFBO0tBQzFCO0FBQ0gsQ0FBQztBQUVEOzs7Ozs7O0dBT0c7QUFDSCxTQUFTLE1BQU0sQ0FBQyxNQUFXLEVBQUUsSUFBVSxFQUFFLFlBQW1DLEVBQUUsVUFBdUI7SUFDM0YsSUFBQSxvQkFBRyxFQUFFLDBCQUFNLEVBQUUsMEJBQU0sQ0FBZTtJQUUxQyxJQUFJLEVBQUUsQ0FBQTtJQUNOLFdBQVc7SUFDWCxPQUFPLElBQUksT0FBTyxDQUFDLFVBQUMsT0FBTyxFQUFFLE1BQU07UUFDakMsTUFBTSxDQUFDLFVBQVUsQ0FDZjtZQUNFLEdBQUcsRUFBRSxHQUFHLENBQUMsVUFBVSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxHQUFHO1lBQzdDLE1BQU0sRUFBRSxNQUFNO1lBQ2QsVUFBVSxFQUFFLElBQUk7WUFDaEIsZ0JBQWdCLEVBQUUsVUFBVSxpQkFBaUIsRUFBRSxXQUFXO2dCQUN4RCxJQUFNLE9BQU8sR0FBRyxpQkFBaUIsR0FBRyxXQUFXLENBQUE7Z0JBQy9DLFlBQVksQ0FBQyxRQUFRLElBQUksWUFBWSxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsQ0FBQTtZQUN6RCxDQUFDO1lBQ0QsY0FBYyxFQUFFLFVBQVUsQ0FBQyxFQUFFLGdCQUFnQjtnQkFDM0MsbUJBQW1CO2dCQUNuQixvQkFBb0I7Z0JBQ3BCLE9BQU87Z0JBQ1AsRUFBRSxHQUFHLGdCQUFnQixDQUFBO1lBQ3ZCLENBQUM7U0FDRixFQUNELFVBQUMsR0FBRyxFQUFFLE1BQU07WUFDVixJQUFJLEdBQUcsRUFBRTtnQkFDUCxPQUFPLENBQUMsS0FBSyxDQUFDLFVBQVUsR0FBRyxHQUFHLENBQUMsQ0FBQTtnQkFDL0IseUJBQXlCO2dCQUN6QixNQUFNLENBQUMsVUFBVSxDQUFDO29CQUNoQixnQkFBZ0IsRUFBRSxFQUFFO29CQUNwQixnQkFBZ0IsRUFBRSxVQUFVLGlCQUFpQixFQUFFLFdBQVc7d0JBQ3hELElBQU0sT0FBTyxHQUFHLGlCQUFpQixHQUFHLFdBQVcsQ0FBQTt3QkFDL0MsWUFBWSxDQUFDLFFBQVEsSUFBSSxZQUFZLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxDQUFBO29CQUN6RCxDQUFDO2lCQUNGLEVBQUUsVUFBVSxHQUFHLEVBQUUsTUFBTTtvQkFDdEIsSUFBSSxHQUFHLEVBQUU7d0JBQ1AsT0FBTyxDQUFDLEtBQUssQ0FBQyxVQUFVLEdBQUcsR0FBRyxDQUFDLENBQUE7d0JBQy9CLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQTtxQkFDWjt5QkFBTTt3QkFDTCxPQUFPLENBQUMsR0FBRyxDQUFDLFVBQVUsRUFBRSxNQUFNLENBQUMsQ0FBQTt3QkFDL0IsT0FBTyxDQUFDOzRCQUNOLE1BQU0sRUFBRSxNQUFNLENBQUMsU0FBUyxDQUFDLE1BQU07NEJBQy9CLElBQUksRUFBRTtnQ0FDSixHQUFHLEVBQUUsWUFBWSxDQUFDLE1BQU0sRUFBRSxNQUFNLEVBQUUsR0FBRyxDQUFDO2dDQUN0QyxHQUFHLEtBQUE7NkJBQ0o7eUJBQ0YsQ0FBQyxDQUFBO3FCQUNIO2dCQUNILENBQUMsQ0FBQyxDQUFBO2FBQ0g7aUJBQU07Z0JBQ0wsT0FBTyxDQUFDLEdBQUcsQ0FBQyxVQUFVLEVBQUUsTUFBTSxDQUFDLENBQUE7Z0JBQy9CLE9BQU8sQ0FBQztvQkFDTixNQUFNLEVBQUUsTUFBTSxDQUFDLFNBQVMsQ0FBQyxNQUFNO29CQUMvQixJQUFJLEVBQUU7d0JBQ0osR0FBRyxFQUFFLFlBQVksQ0FBQyxNQUFNLEVBQUUsTUFBTSxFQUFFLEdBQUcsQ0FBQzt3QkFDdEMsR0FBRyxLQUFBO3FCQUNKO2lCQUNGLENBQUMsQ0FBQTthQUNIO1FBQ0gsQ0FBQyxDQUFDLENBQUE7SUFDTixDQUFDLENBQUMsQ0FBQTtBQUNKLENBQUM7QUFFRDs7Ozs7R0FLRztBQUNILFNBQVMsWUFBWSxDQUFDLEdBQVcsRUFBRSxNQUEwQjtJQUMzRCxJQUFJLFVBQVUsR0FBTSxHQUFHLHdDQUFtQyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUcsQ0FBQTtJQUMzRSxJQUFJLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUFFO1FBQ25CLFVBQVUsSUFBSSxRQUFNLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBRyxDQUFBO0tBQ3RDO0lBQ0QsT0FBTyxVQUFVLENBQUE7QUFDbkIsQ0FBQztBQUVELGtCQUFlO0lBQ2IsVUFBVSxZQUFBO0lBQ1YsTUFBTSxRQUFBO0lBQ04sWUFBWSxjQUFBO0NBQ2IsQ0FBQSJ9